import React from 'react';
import { Input, Label, Select } from './StyledComponents';

const AssetAvailabilityFields = ({
  availabilityType,
  availableFromAge,
  availableFromDate,
  onAvailabilityTypeChange,
  onAvailableFromAgeChange,
  onAvailableFromDateChange,
}) => (
  <>
    <Label>Available to cash projection:</Label>
    <Select value={availabilityType} onChange={onAvailabilityTypeChange}>
      <option value="now">Available now</option>
      <option value="age">From age</option>
      <option value="date">From date</option>
    </Select>
    {availabilityType === 'age' && (
      <>
        <Label>Available from age:</Label>
        <Input
          type="number"
          min="0"
          max="120"
          step="1"
          value={availableFromAge}
          onChange={onAvailableFromAgeChange}
          required
        />
      </>
    )}
    {availabilityType === 'date' && (
      <>
        <Label>Available from date:</Label>
        <Input
          type="date"
          value={availableFromDate}
          onChange={onAvailableFromDateChange}
          required
        />
      </>
    )}
  </>
);

export default AssetAvailabilityFields;
